import React from 'react';
import { motion } from 'framer-motion';
export function UrgencyBar() {
  return <motion.div className="bg-charcoal/75 backdrop-blur-md text-white sticky top-0 z-50 border-b border-gold/15" animate={{
    scale: [1, 1.02, 1, 1.015, 1],
    boxShadow: ['0 2px 8px rgba(197,165,90,0.1)', '0 4px 24px rgba(197,165,90,0.5)', '0 2px 8px rgba(197,165,90,0.1)', '0 3px 18px rgba(197,165,90,0.35)', '0 2px 8px rgba(197,165,90,0.1)'],
    borderColor: ['rgba(197,165,90,0.15)', 'rgba(197,165,90,0.5)', 'rgba(197,165,90,0.15)', 'rgba(197,165,90,0.4)', 'rgba(197,165,90,0.15)']
  }} transition={{
    duration: 1.8,
    repeat: Infinity,
    ease: 'easeInOut'
  }} data-id="element-219">
      <div onClick={() => {
      const priceCard = document.getElementById('price-card');
      if (priceCard) {
        priceCard.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }} className="max-w-xl mx-auto px-4 py-2.5 flex flex-col items-center text-center gap-0.5 cursor-pointer" data-id="element-220">
        <p className="text-xs md:text-sm" data-id="element-221">
          <span className="text-base align-middle" data-id="element-222">🕊️</span> Cientos de personas
          ya liberaron su historia.
        </p>
        <p className="text-xs md:text-sm font-medium" data-id="element-223">
          Esta <span className="text-gold font-bold" data-id="element-224">SEMANA SANTA</span> es tu
          momento de <span className="text-gold font-bold" data-id="element-225">FE</span>.
        </p>
        <p className="text-xs md:text-sm mt-0.5" data-id="element-226">
          El precio especial de{' '}
          <span className="text-gold font-bold" data-id="element-227">$8.49 USD</span> expira el:
        </p>
        <p className="text-gold font-serif font-bold text-xs md:text-sm italic" data-id="element-228">
          Viernes Santo — 3 de Abril — 11:59 PM
        </p>
      </div>
    </motion.div>;
}